import React from 'react';
import { Link } from 'react-router-dom';
import { UserPlus } from 'lucide-react';
import { Button } from '@dashboard/components/ui/button';
import CardHeaderTitle from '@dashboard/components/CardHeaderTitle';
import StaffList from './StaffList';

interface Props {
  pageId: string;
  sellerId: string;
  canManage: boolean;
}

const ManageStaffPanel: React.FC<Props> = ({ pageId, sellerId, canManage }) => {
  return (
    <StaffList
      pageId={pageId}
      sellerId={sellerId}
      canManage={canManage}
      title={<CardHeaderTitle variant="page">Manage staff</CardHeaderTitle>}
      actions={
        canManage && (
          <Button asChild>
            <Link to={`/pages/${pageId}/staff/invite`}>
              <UserPlus className="size-3.5 mr-1.5" />
              Invite staff
            </Link>
          </Button>
        )
      }
    />
  );
};

export default ManageStaffPanel;
